import React, { useState, createContext, ReactNode, SetStateAction, useEffect } from 'react';
import { getCarrierList } from '../services/APIs';

export interface Precheck {
    submittedReferenceId: string;
    driverId: string;
    submittedName: string;
    submittedDotNumber:string;
    submittedPhoneNumber: string;
    submittedTrailerNumber: string;
    submittedTrailerLength: string;
    orgId: string;
    plantId: string;
    orgCode: string;
    language: 'en' | 'es' | 'ru';
    isOffsite: boolean;
    submittedVisitType: 'LL' | 'PL';
    hasTrailer: boolean;
    isOrderFound: boolean;
    precheckId: string;
}

interface Order {
    manhDeliveryId: string;
    manhCustomerPo: string;
    manhTripId: string;
    manhVisitType: 'PL' | 'LL' | 'DE' | 'UL' | '';
    manhCarrierSCAC: string;
    manhCarrierName: string;
    manhAddress: string;
    manhCustomerName: string;
    manhPickupAppointment: Date;
    manhDeliveryAppointment: Date;
}

interface Carrier {
    scac: string;
    name: string;
}

interface PrecheckContext {
    precheckInfo: Precheck;
    setPrecheckInfo: React.Dispatch<SetStateAction<Precheck>>;
    orderInfo: Order;
    setOrderInfo: React.Dispatch<SetStateAction<Order>>;
    isAuthenticated: boolean;
    setIsAuthenticated: React.Dispatch<SetStateAction<boolean>>;
    carrierList?: Carrier[];
    setCarrierList?: React.Dispatch<SetStateAction<Carrier[]>>;
    usDotFieldEnabled: boolean;
    setUsDotFieldEnabled: React.Dispatch<SetStateAction<boolean>>;
}

interface PrecheckContextProps {
    children: ReactNode;
}

export const PrecheckContext = createContext<PrecheckContext>({} as PrecheckContext);

export const PrecheckProvider = (props: PrecheckContextProps) => {
    const [precheckInfo, setPrecheckInfo] = useState<Precheck>({
        submittedName: '',
        submittedDotNumber: '',
        driverId: '',
        submittedPhoneNumber: '',
        submittedReferenceId: '',
        submittedTrailerNumber: '',
        submittedTrailerLength: '53',
        language: 'en',
        isOffsite: true,
        orgId: '',
        plantId: '',
        orgCode: '',
        submittedVisitType: 'LL',
        hasTrailer: true,
        isOrderFound: false,
        precheckId: ''
    });
    const [orderInfo, setOrderInfo] = useState<Order>({
        manhDeliveryId: '',
        manhCustomerPo: '',
        manhTripId: '',
        manhVisitType: '',
        manhAddress: '',
        manhCarrierName: '',
        manhCarrierSCAC: '',
        manhCustomerName: '',
        manhPickupAppointment: new Date(0),
        manhDeliveryAppointment: new Date(0)
    });
    const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
    const [carrierList, setCarrierList] = useState<Carrier[]>([]);
    const [usDotFieldEnabled, setUsDotFieldEnabled] = useState<boolean>(false);

    const updateCarrierList = async () => {
        const carrierResponse = await getCarrierList();
        setCarrierList(carrierResponse.data.carriers);
    };

    useEffect(() => {
        if (isAuthenticated) updateCarrierList();
    }, [isAuthenticated]);

    useEffect(() => {
        if (process.env.REACT_APP_IS_DEV) console.log({ precheckInfo });
    }, [precheckInfo]);

    return (
        <PrecheckContext.Provider
            value={{
                precheckInfo,
                setPrecheckInfo,
                orderInfo,
                setOrderInfo,
                isAuthenticated,
                setIsAuthenticated,
                carrierList,
                setCarrierList,
                usDotFieldEnabled,
                setUsDotFieldEnabled
            }}>
            {props.children}
        </PrecheckContext.Provider>
    );
};
